import {NavLink} from "react-router-dom";

function SidebarLinkGroupLinkDesign({name, isCurrent}) {
    return <span
        className="submenu-link text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
            {name}
        </span>;
}

export default function SidebarLinkGroupLink({route}) {
    let current = route['is_current'];
    let linkClass = route['is_current'] ? 'text-violet-500' : 'text-gray-500/90 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200';

    if (route['name'] === null) {
        return <li></li>;
    }

    return (<li className="mb-1 last:mb-0">
        {route['path'] && <NavLink className={`block transition truncate ${linkClass}`} end to={route['path']}>
            <SidebarLinkGroupLinkDesign name={route['name']} isCurrent={current}/>
        </NavLink>}
        {route['href'] && <a target={'_blank'} href={route['href']}>
            <SidebarLinkGroupLinkDesign name={route['name']} isCurrent={current}/>
        </a>}
    </li>);
}